import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/ds.css';
import './styles/investments-charts.css';
import App from './App.tsx';


document.documentElement.lang = 'pt-BR';
try {
  const meta = document.createElement('meta');
  meta.name = 'gp-build';
  meta.content = `${process.env.REACT_APP_BUILD_SHA || 'local'}@${process.env.REACT_APP_BUILD_TIME || ''}`;
  document.head.appendChild(meta);
} catch (_) {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
